import CT from 'constants/contentType.const';
import inspectResponse from 'utils/backend/inspectResponse.util';
import parseJson from 'utils/parsers/parseJson';

// used for mocking fetches while developing in the FE
const callMock = (mocker) => async (options) => {
  const r = await mocker(options ?? {});

  if (!(r instanceof Response)) {
    throw new TypeError(`Mock function ${mocker} didn't return a Response object for options: ${options}`);
  }

  const is = inspectResponse(r);
  const ct = is.json ? CT.json : CT.text;

  if (is.noContent) return { response: r, ctype: ct, is, status: r.status };

  const text = await r.text();
  const json = is.json ? parseJson(text) : void 1;

  return { response: r, ctype: ct, is, status: r.status, text, json };
};

export default callMock;
